import * as R from 'ramda'

import { EventStatusId } from '@collector/sportsapi-client-legacy'
import { useSportMaps } from '@desktop/views/Relation/composables'

import { injectEventStatusAcronymConfig } from '../Sports/provide-inject'

export function useEventStatusName(): {
  getEventStatusAcronym(eventStatusId: EventStatusId): string | null
  getEventStatusName(eventStatusId: EventStatusId): string | null
} {
  const { eventStatusToSportStatusMap } = useSportMaps()
  const eventStatusAcronymConfig = injectEventStatusAcronymConfig()

  function getEventStatusAcronym(eventStatusId: EventStatusId): string | null {
    return eventStatusAcronymConfig
      ? ((R.prop(eventStatusId, eventStatusAcronymConfig) as string) ?? null)
      : null
  }

  function getEventStatusName(eventStatusId: EventStatusId): string | null {
    const eventStatus = eventStatusToSportStatusMap.value[eventStatusId]

    return eventStatus?.name ?? null
  }

  return {
    getEventStatusAcronym,
    getEventStatusName,
  }
}
